/**
 * Shows a Google Static Map (chart outline on a real map image), then loads
 * Dynamic Maps only after the shopper clicks or tries to pan/zoom.
 *
 * Static Maps: US$2 / 1,000 after 10,000 free. Dynamic Maps: US$7 / 1,000.
 * Enable "Maps Static API" on the same key in Google Cloud.
 *
 * Theme must set window.GE_MAPS_API_KEY. GIS lists should be on the page.
 */
(function (window, document) {
  'use strict';

  var loading = false;
  var loaded = false;
  var MAX_PREVIEW_POLYS = 8;
  var MAX_PATH_POINTS = 20;

  function mapsScriptUrl(key) {
    return (
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(key) +
      '&callback=initMap&loading=async&v=weekly'
    );
  }

  function wrapEl() {
    return document.getElementById('map-wrap') || document.getElementById('map');
  }

  function hidePreview() {
    var wrap = wrapEl();
    if (wrap) wrap.classList.add('is-loaded');
  }

  function injectMapsScript() {
    if (loaded || loading) return;
    if (window.google && window.google.maps && typeof window.initMap === 'function') {
      loaded = true;
      hidePreview();
      window.initMap();
      return;
    }

    var key = window.GE_MAPS_API_KEY;
    if (!key) {
      window.console && console.error('GE_MAPS_API_KEY is missing');
      return;
    }

    loading = true;
    var wrap = wrapEl();
    if (wrap) wrap.classList.add('is-upgrading');

    var script = document.createElement('script');
    script.src = mapsScriptUrl(key);
    script.async = true;
    script.defer = true;
    script.onerror = function () {
      loading = false;
      if (wrap) wrap.classList.remove('is-upgrading');
    };
    script.onload = function () {
      loaded = true;
      hidePreview();
    };
    document.head.appendChild(script);
  }

  function getCoords(dataArray) {
    var coords = dataArray[1];
    var scale = dataArray[2];
    var vendor = dataArray[3];

    if (coords == '') {
      var latS, latN, lonW, lonE, col, row;

      if (scale >= 250000) {
        var letters = ['c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'];
        var num = dataArray[0].replace(vendor, '').match(/.{1,2}/g);
        row = letters.indexOf(num[0].replace('s', '')) + 2;
        col = parseInt(num[1], 10);
        lonW = (col - 49) * 6 + 108;
        lonE = lonW + 6;
        latN = row * -4;
        latS = latN - 4;

        if (scale == 250000) {
          num = parseInt(dataArray[0].replace(vendor, '').match(/.{1,5}/g)[1], 10);
          if (num <= 4) latS += 3;
          else if (num <= 8) {
            latS += 2;
            latN -= 1;
          } else if (num <= 12) {
            latS += 1;
            latN -= 2;
          } else latN -= 3;

          if (num == 1 || num == 5 || num == 9 || num == 13) lonE -= 4.5;
          else if (num == 2 || num == 6 || num == 10 || num == 14) {
            lonE -= 3;
            lonW += 1.5;
          } else if (num == 3 || num == 7 || num == 11 || num == 15) {
            lonE -= 1.5;
            lonW += 3;
          } else lonW += 4.5;
        }
      }

      if (scale <= 100000) {
        var parts = dataArray[0].replace(vendor, '').match(/.{1,2}/g);
        col = parts[0];
        row = parts[1];
        lonW = col * 0.5 + 105.5;
        lonE = lonW + 0.5;
        latS = -49 + row * 0.5;
        latN = latS + 0.5;

        if (vendor != 'nsw' && vendor != 'tas') {
          if (scale <= 50000) {
            var quad = parseInt(parts[2].replace('-', ''), 10);
            if (quad == 1 || quad == 2) lonW += 0.25;
            if (quad == 3 || quad == 4) lonE -= 0.25;
            if (quad == 1 || quad == 4) latS += 0.25;
            if (quad == 2 || quad == 3) latN -= 0.25;
            if (scale <= 25000) {
              quad = parseInt(parts[3], 10);
              if (quad == 1 || quad == 2) lonW += 0.125;
              if (quad == 3 || quad == 4) lonE -= 0.125;
              if (quad == 1 || quad == 4) latS += 0.125;
              if (quad == 2 || quad == 3) latN -= 0.125;
            }
          }
        } else if (vendor == 'nsw') {
          if (scale <= 50000) {
            var ns = parts[2].replace('-', '');
            if (ns == 'n') latS += 0.25;
            if (ns == 's') latN -= 0.25;
          }
          if (scale <= 25000) {
            quad = parseInt(parts[2].replace('-', ''), 10);
            if (quad == 1 || quad == 2) lonW += 0.25;
            if (quad == 3 || quad == 4) lonE -= 0.25;
            if (quad == 1 || quad == 4) latS += 0.25;
            if (quad == 2 || quad == 3) latN -= 0.25;
            ns = parts[3];
            if (ns == 'n') latS += 0.125;
            if (ns == 's') latN -= 0.125;
          }
        }
      }

      coords = [
        [latN, lonW],
        [latN, lonE],
        [latS, lonE],
        [latS, lonW],
        [latN, lonW]
      ];
    }

    var out = [];
    for (var i = 0; i < coords.length; i++) {
      out.push({ lat: coords[i][0], lng: coords[i][1] });
    }
    return out;
  }

  function polyColour(dataArray) {
    var colours = window.colours || {};
    if (
      (dataArray[4] == 'map' || dataArray[4] == 'folded_map') &&
      dataArray[3] != 'hema' &&
      dataArray[3] != 'world'
    ) {
      return colours[dataArray[3] + dataArray[2] + dataArray[5]] || '#FF0000';
    }
    return colours[dataArray[3]] || '#FF0000';
  }

  function gisLists() {
    var lists = [];
    if (typeof chart_list !== 'undefined') lists.push(chart_list);
    if (typeof map_list !== 'undefined') lists.push(map_list);
    if (typeof enc_list !== 'undefined') lists.push(enc_list);
    if (typeof ukho_list !== 'undefined') lists.push(ukho_list);
    if (typeof pub_list !== 'undefined') lists.push(pub_list);
    return lists;
  }

  function handlesToShow() {
    if (typeof showOnly !== 'undefined' && showOnly && showOnly.length && showOnly[0] != 'x') {
      return showOnly;
    }
    if (typeof productHandle !== 'undefined' && productHandle) {
      return [productHandle];
    }
    return [];
  }

  function recordsToShow() {
    var handles = handlesToShow();
    var wanted = {};
    for (var i = 0; i < handles.length; i++) {
      wanted[String(handles[i]).toLowerCase()] = true;
    }

    var found = [];
    var lists = gisLists();
    for (var l = 0; l < lists.length; l++) {
      var list = lists[l];
      for (var r = 0; r < list.length; r++) {
        var handle = String(list[r][0]).toLowerCase();
        if (wanted[handle]) {
          found.push(list[r]);
          if (found.length >= MAX_PREVIEW_POLYS) return found;
        }
      }
    }
    return found;
  }

  function hexToStatic(hex, alphaHex) {
    var value = String(hex || '#FF0000').replace('#', '');
    if (value.length === 3) {
      value = value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
    }
    return '0x' + value.toUpperCase() + (alphaHex || 'FF');
  }

  function simplify(coords) {
    if (coords.length <= MAX_PATH_POINTS) return coords;
    var step = Math.ceil(coords.length / MAX_PATH_POINTS);
    var out = [];
    for (var i = 0; i < coords.length; i += step) out.push(coords[i]);
    var last = coords[coords.length - 1];
    if (out[out.length - 1] !== last) out.push(last);
    return out;
  }

  function pathParam(coords, colour) {
    var pts = simplify(coords);
    var parts = [
      'color:' + hexToStatic(colour, 'FF'),
      'weight:2',
      'fillcolor:' + hexToStatic(colour, '4D')
    ];
    for (var i = 0; i < pts.length; i++) {
      parts.push(pts[i].lat.toFixed(5) + ',' + pts[i].lng.toFixed(5));
    }
    return parts.join('|');
  }

  function bboxPath(coords, colour) {
    var box = coordsBBox(coords);
    return pathParam(
      [
        { lat: box.maxLat, lng: box.minLng },
        { lat: box.maxLat, lng: box.maxLng },
        { lat: box.minLat, lng: box.maxLng },
        { lat: box.minLat, lng: box.minLng },
        { lat: box.maxLat, lng: box.minLng }
      ],
      colour
    );
  }

  function coordsBBox(coords) {
    var minLat = coords[0].lat;
    var maxLat = coords[0].lat;
    var minLng = coords[0].lng;
    var maxLng = coords[0].lng;
    for (var i = 1; i < coords.length; i++) {
      if (coords[i].lat < minLat) minLat = coords[i].lat;
      if (coords[i].lat > maxLat) maxLat = coords[i].lat;
      if (coords[i].lng < minLng) minLng = coords[i].lng;
      if (coords[i].lng > maxLng) maxLng = coords[i].lng;
    }
    return { minLat: minLat, maxLat: maxLat, minLng: minLng, maxLng: maxLng };
  }

  function mercatorX(lng, z) {
    return ((lng + 180) / 360) * 256 * Math.pow(2, z);
  }

  function mercatorY(lat, z) {
    var s = Math.sin((lat * Math.PI) / 180);
    return (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * 256 * Math.pow(2, z);
  }

  function zoomToFit(minLat, maxLat, minLng, maxLng, width, height) {
    for (var z = 12; z >= 3; z--) {
      var w = Math.abs(mercatorX(maxLng, z) - mercatorX(minLng, z));
      var h = Math.abs(mercatorY(minLat, z) - mercatorY(maxLat, z));
      if (w <= width && h <= height) return z;
    }
    return 3;
  }

  function staticMapUrl(records, width, height) {
    var key = window.GE_MAPS_API_KEY;
    if (!key) return '';

    var w = Math.max(200, Math.min(640, Math.round(width) || 640));
    var h = Math.max(200, Math.min(400, Math.round(height) || 400));
    var prepared = [];
    var minLat = 90;
    var maxLat = -90;
    var minLng = 180;
    var maxLng = -180;

    for (var i = 0; i < records.length; i++) {
      var coords = getCoords(records[i]);
      if (!coords.length) continue;
      prepared.push({ coords: coords, colour: polyColour(records[i]) });
      var box = coordsBBox(coords);
      if (box.minLat < minLat) minLat = box.minLat;
      if (box.maxLat > maxLat) maxLat = box.maxLat;
      if (box.minLng < minLng) minLng = box.minLng;
      if (box.maxLng > maxLng) maxLng = box.maxLng;
    }

    if (!prepared.length) return '';

    var latPad = (maxLat - minLat) * 0.35 || 0.25;
    var lngPad = (maxLng - minLng) * 0.35 || 0.25;
    var viewMinLat = minLat - latPad;
    var viewMaxLat = maxLat + latPad;
    var viewMinLng = minLng - lngPad;
    var viewMaxLng = maxLng + lngPad;
    var zoom = zoomToFit(viewMinLat, viewMaxLat, viewMinLng, viewMaxLng, w, h);
    var centerLat = (viewMinLat + viewMaxLat) / 2;
    var centerLng = (viewMinLng + viewMaxLng) / 2;

    var url =
      'https://maps.googleapis.com/maps/api/staticmap?size=' +
      w +
      'x' +
      h +
      '&scale=1&maptype=roadmap&center=' +
      centerLat.toFixed(5) +
      ',' +
      centerLng.toFixed(5) +
      '&zoom=' +
      zoom +
      '&key=' +
      encodeURIComponent(key);

    for (var p = 0; p < prepared.length; p++) {
      var path = pathParam(prepared[p].coords, prepared[p].colour);
      if ((url + path).length > 7500) path = bboxPath(prepared[p].coords, prepared[p].colour);
      url += '&path=' + encodeURIComponent(path);
    }
    return url;
  }

  function ensurePreviewEl() {
    var wrap = document.getElementById('map-wrap');
    if (!wrap) return null;
    var preview = document.getElementById('ge-map-preview');
    if (!preview) {
      preview = document.createElement('div');
      preview.id = 'ge-map-preview';
      preview.className = 'ge-map-preview';
      preview.setAttribute('aria-hidden', 'true');
      wrap.insertBefore(preview, wrap.firstChild);
    }
    return preview;
  }

  function softenOverlay() {
    var wrap = document.getElementById('map-wrap');
    if (!wrap) return;
    wrap.classList.add('has-preview');
    var overlay = wrap.querySelector('.ge-map-overlay');
    if (overlay) {
      overlay.style.background = 'transparent';
      overlay.style.top = 'auto';
      overlay.style.bottom = '18px';
      overlay.style.height = 'auto';
      overlay.style.alignItems = 'flex-end';
    }
    var btn = wrap.querySelector('[data-ge-map-load]');
    if (btn && /view coverage map/i.test(btn.textContent)) {
      btn.textContent = 'Click to pan and zoom';
    }
  }

  function renderPreview() {
    var wrap = document.getElementById('map-wrap');
    var preview = ensurePreviewEl();
    if (!wrap || !preview || wrap.classList.contains('is-loaded')) return false;
    if (preview.getAttribute('data-ready') === '1') return true;

    var records = recordsToShow();
    if (!records.length) return false;

    var url = staticMapUrl(records, wrap.clientWidth || 640, wrap.clientHeight || 400);
    if (!url) return false;

    var img = document.createElement('img');
    img.className = 'ge-map-static';
    img.alt = 'Chart coverage';
    img.decoding = 'async';
    img.src = url;
    img.onload = function () {
      preview.setAttribute('data-ready', '1');
      softenOverlay();
    };
    img.onerror = function () {
      window.console &&
        console.warn(
          'Static map failed. Enable Maps Static API on this key in Google Cloud.'
        );
    };

    preview.innerHTML = '';
    preview.appendChild(img);
    softenOverlay();
    return true;
  }

  function tryRenderPreview(attempt) {
    if (renderPreview()) return;
    if (attempt > 50) return;
    setTimeout(function () {
      tryRenderPreview(attempt + 1);
    }, 100);
  }

  function bind() {
    var wrap = document.getElementById('map-wrap');
    var buttons = document.querySelectorAll('[data-ge-map-load]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', injectMapsScript);
    }
    if (wrap) {
      wrap.addEventListener('click', injectMapsScript);
      wrap.addEventListener(
        'wheel',
        function (event) {
          event.preventDefault();
          injectMapsScript();
        },
        { passive: false }
      );
    }
    tryRenderPreview(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.loadCairnsMap = injectMapsScript;
})(window, document);
